const homeTopSlides = {
  slides: [{
    caption: 'Jamaica is home to endless white-sand beaches including Negril’s famous Seven Mile Beach.',
    link: '/specials/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/jamaica/top-slides/beach-and-sunlounger.jpg'
  },
  {
    caption: 'Experience the warmth and hospitality that Jamaica is known for at Beaches Resorts.',
    link: '/specials/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/jamaica/top-slides/old-people.jpg'
  },
  {
    caption: 'Some of the most unforgettable dive sites can be found off the coast of Jamaica.',
    link: '/liv-plus/real-madrid-clinic/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/jamaica/top-slides/scuba.jpg'
  }]
};

module.exports = homeTopSlides;
